/**
 * Every visible site's onboarding agent at a glance (#219 asked for it):
 * a wrong binding on ANOTHER site is otherwise invisible from this one.
 * Presentational; ProjectAgentPicker computes the rows.
 */
import { Icons } from 'turbotwin-sdk/icons';
import { Icon } from '@/components/Icon';

export type AgentBindingLine = {
  key: string;
  siteName: string;
  agentName: string;
  problem: string | null;
  isCurrentSite: boolean;
};

export function AgentBindingsList({ lines }: { lines: AgentBindingLine[] }) {
  if (lines.length < 2) return null;
  return (
    <div style={{ marginTop: 10, display: 'grid', gap: 3 }}>
      <div className="label-up">Agents on all sites</div>
      {lines.map((l) => (
        <div key={l.key} style={{ display: 'flex', gap: 8, fontSize: 12, alignItems: 'baseline' }}>
          <span style={{ minWidth: 180, fontWeight: l.isCurrentSite ? 600 : 400 }}>{l.siteName}</span>
          <span style={{ color: 'var(--muted)' }}>{l.agentName}</span>
          {l.problem ? (
            <span className="pill plain warn" title={l.problem} style={{ fontSize: 10.5 }}>
              <Icon of={Icons.status.warning} size={11} /> {l.problem}
            </span>
          ) : null}
        </div>
      ))}
    </div>
  );
}
